var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNsfwEyeNone = function SvgNsfwEyeNone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.867 3.8C7.2 3.667 7.6 3.667 8 3.667 11.8 3.667 14 8 14 8c-.333.6-.733 1.2-1.2 1.734m-3.667-.6c-.133.133-.333.266-.533.4-.2.066-.4.133-.667.133-.2 0-.466 0-.666-.133-.2-.067-.4-.2-.534-.334-.066-.133-.2-.333-.266-.533-.067-.2-.134-.4-.134-.667 0-.2.067-.466.134-.666.066-.134.2-.334.4-.467m4.4 4.4A5.25 5.25 0 0 1 8 12.4c-3.8 0-6-4.333-6-4.333A10 10 0 0 1 4.733 4.8zM2 2l12 12"
  })));
};
export default SvgNsfwEyeNone;